﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PrefixId;
(function (PrefixId) {
    PrefixId["AppBar"] = "ab";
    PrefixId["ExtendedFields"] = "exf";
    PrefixId["GenericFormHelpers"] = "gfh";
    PrefixId["UserProfileForm"] = "upf";
    PrefixId["UpdatePasswordFields"] = "rpi";
})(PrefixId = exports.PrefixId || (exports.PrefixId = {}));
//# sourceMappingURL=Identifiers.js.map